import React from 'react'
import { createPortal } from 'react-dom'
import { Spinner } from '@phosphor-icons/react'
import { cn } from '../lib/utils'

type BlockingOverlayProps = {
  open: boolean
  title?: string
  description?: string
  className?: string
}

export default function BlockingOverlay({
  open,
  title = 'Please wait...',
  description,
  className
}: BlockingOverlayProps) {
  if (!open) return null
  if (typeof document === 'undefined') return null

  return createPortal(
    <div
      className={cn(
        // Use a very high z-index to ensure the overlay sits above any popovers/modals.
        'fixed inset-0 flex items-center justify-center bg-black/35 backdrop-blur-sm',
        className
      )}
      style={{ zIndex: 2147483647 }}
      role="alert"
      aria-live="assertive"
      aria-busy="true"
    >
      <div className="mx-4 w-full max-w-sm rounded-2xl bg-white/95 border border-white/40 shadow-2xl px-8 py-7">
        <div className="flex flex-col items-center text-center gap-3">
          <Spinner size={56} className="animate-spin text-slate-800" />
          <div className="text-xl font-extrabold tracking-tight text-slate-900">{title}</div>
          {description ? (
            <div className="text-sm text-slate-600">{description}</div>
          ) : null}
        </div>
      </div>
    </div>,
    document.body
  )
}
